import { useSchoolDistrictCreateNewDistrict } from "@crowdcoursing/api/openapi";
import { Grid, Typography } from "@mui/material";
import { useCallback } from "react";

import {
  CreateDistrictTemplate,
  type CreateDistrictTemplateProps,
  type FormValues,
} from "../../templates/CreateDistrictTemplate";

// Component strings
const tNewDistrictDetails = "New District Details";
const tCreateFailed = "Failed to create district. Please try again.";

interface CreateDistrictProps {
  onClose: () => void;
}

// Default initial values
const initialValues: FormValues = {
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  county: "",
  districtName: "",
  phoneNumber: "",
  state: "",
  stateInitials: "",
  website: "",
};

export const CreateDistrict = ({ onClose }: CreateDistrictProps) => {
  const createDistrictMutation = useSchoolDistrictCreateNewDistrict();

  const handleSubmit = useCallback<CreateDistrictTemplateProps["onSubmit"]>(
    async (values: FormValues) => {
      try {
        const requestBody = {
          addressLine1: values.addressLine1,
          addressLine2: values.addressLine2 || null,
          addressLine3: values.addressLine3 || null,
          county: values.county,
          districtName: values.districtName,
          phoneNumber: values.phoneNumber || null,
          state: values.state,
          stateInitials: values.stateInitials,
          website: values.website || null,
        };

        await createDistrictMutation.mutateAsync({
          body: requestBody,
          pathParams: { bubbleId: "1ab016ad-6a85-4f40-9fea-9f22dffc4172" },
        });

        onClose();
        return;
      } catch {
        return { FORM_ERROR: tCreateFailed };
      }
    },
    [createDistrictMutation, onClose],
  );

  return (
    <Grid container>
      <Grid size={12}>
        <Grid container justifyContent="center">
          <Grid
            size={{
              md: 8,
              xs: 10,
            }}
          >
            <Typography sx={{ textAlign: "center" }} variant="h5">
              {tNewDistrictDetails}
            </Typography>
            <CreateDistrictTemplate initialValues={initialValues} onClose={onClose} onSubmit={handleSubmit} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CreateDistrict;
